import React, { useState } from 'react';

import {
  useDataProvider,
  useNotify,
  useRecordContext,
  useRefresh,
} from 'react-admin';

import CancelIcon from '@mui/icons-material/Cancel';
import { Button } from '@mui/material';
import { DashboardResources } from '@src/types';

import CancelRepairDialog from './CancelRepairDialog';

const CANCELABLE_STATES = [
  'Under Review',
  'Payment Pending',
  'Approved',
];

const CancelRepairAction = () => {
  const notify = useNotify();
  const refresh = useRefresh();
  const record = useRecordContext();
  const dataProvider = useDataProvider();

  const [isDialogLoading, setIsDialogLoading] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  if (!record || !CANCELABLE_STATES.includes(record.status)) {
    return null;
  }

  const handleDialogClose = () => setIsDialogOpen(false);
  const handleDialogOpen = () => setIsDialogOpen(true);
  const handleDialogCancel = async () => {
    try {
      setIsDialogLoading(true);

      await dataProvider.cancel(DashboardResources.Repairs, {
        repairUuid: record.id,
      });

      notify('Repair canceled successfully.', { type: 'success' });
      refresh();
      setIsDialogOpen(false);
    } catch (error) {
      console.error(error);
      notify('Error canceling repair.', { type: 'error' });
    } finally {
      setIsDialogLoading(false);
    }
  };

  return (
    <>
      <Button
        color="error"
        onClick={handleDialogOpen}
        size="small"
        startIcon={<CancelIcon />}
        variant="text"
      >
        Cancel Repair
      </Button>
      <CancelRepairDialog
        handleCancel={handleDialogCancel}
        handleClose={handleDialogClose}
        isLoading={isDialogLoading}
        open={isDialogOpen}
      />
    </>
  );
};

export default CancelRepairAction;